import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "SitePageStatisticContainer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_BatterTableDataView, {
    "init-query": {
      siteId: $props.site.value
    },
    "table-id": 8,
    "page-size-choices": [500]
  }, null, 8, ["init-query"]), _createVNode(_component_el_row, {
    class: "mt16"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      style: {
        "width": "100px"
      },
      onClick: $options.exportAsXlsx
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("导出")])),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  })]);
}